export default __webpack_public_path__ + "static/media/calendar-icon.41df89b9.svg";